var render = function (_h,_vm) {var _c=_vm._c;return _c('td',{staticClass:"border-l border-r border-gray-200 px-3 py-1 text-sm leading-tight tabular-nums align-top"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }